import { render, staticRenderFns } from "./chatPlugin.vue?vue&type=template&id=1c8f68e5&"
import script from "./chatPlugin.vue?vue&type=script&lang=js&"
export * from "./chatPlugin.vue?vue&type=script&lang=js&"
import style0 from "./chatPlugin.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports